import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';

const socket = io('https://api.krukshop.ovh');

const RealtimeStats = ({ shopId }) => {
  const [stats, setStats] = useState({ online: 0, sales: 0 });

  useEffect(() => {
    socket.emit('joinShopRoom', shopId);

    socket.on('updateStats', (newStats) => {
      setStats(newStats);
    });

    return () => {
      socket.emit('leaveShopRoom', shopId);
      socket.off('updateStats');
    };
  }, [shopId]);

  return (
    <div className="mt-8 p-4 border rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Statystyki na żywo</h2>
      <p>Użytkowników online: {stats.online}</p>
      <p>Sprzedaż dzisiaj: {stats.sales}</p>
    </div>
  );
};

export default RealtimeStats;